module.exports = __webpack_public_path__ + "img/text1.ec22d3c1.png";